/* Eleanor Cheltenham — global theme behaviour. No dependencies. */
(function () {
  'use strict';

  /* ---------- Analytics event bus ----------
     Minimal wrapper so every component fires through one place.
     Swap the body of `track()` for GA4 / Shopify Pixels / etc. later. */
  window.EleanorAnalytics = {
    track: function (eventName, payload) {
      document.dispatchEvent(new CustomEvent('eleanor:' + eventName, { detail: payload || {} }));
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.lib) {
        // Native Shopify analytics already tracks page_view / product_view / add_to_cart / checkout.
        // Custom events (cross_sell_click, filter usage, etc.) are exposed via the eleanor: events above
        // for a future pixel/GTM integration, so nothing here duplicates Shopify's own tracking.
      }
    }
  };
  EleanorAnalytics.track('page_view', { path: window.location.pathname });

  /* ---------- Mobile navigation ---------- */
  var navToggle = document.querySelector('[data-mobile-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var navClose = document.querySelector('[data-mobile-nav-close]');

  function focusableElements(container) {
    return Array.prototype.slice.call(container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
  }
  function trapFocus(event, container) {
    if (event.key !== 'Tab' || !container) return;
    var focusable = focusableElements(container);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.removeAttribute('inert');
    mobileNav.setAttribute('aria-hidden', 'false');
    mobileNav.setAttribute('data-open', 'true');
    if (navToggle) navToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    var firstLink = mobileNav.querySelector('a, button');
    if (firstLink) firstLink.focus();
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.setAttribute('data-open', 'false');
    mobileNav.setAttribute('aria-hidden', 'true');
    mobileNav.setAttribute('inert', '');
    if (navToggle) navToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (navToggle) navToggle.focus();
  }
  if (navToggle) navToggle.addEventListener('click', openMobileNav);
  if (navClose) navClose.addEventListener('click', closeMobileNav);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileNav && mobileNav.getAttribute('data-open') === 'true') closeMobileNav();
  });

  /* ---------- Search overlay ---------- */
  var searchToggle = document.querySelectorAll('[data-search-toggle]');
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchClose = document.querySelector('[data-search-close]');
  var searchInput = document.querySelector('[data-search-input]');

  var searchReturnFocus = null;
  function openSearch() {
    if (!searchOverlay) return;
    searchReturnFocus = document.activeElement;
    searchOverlay.removeAttribute('inert');
    searchOverlay.setAttribute('aria-hidden', 'false');
    searchOverlay.setAttribute('data-open', 'true');
    searchToggle.forEach(function (button) { button.setAttribute('aria-expanded', 'true'); });
    document.body.style.overflow = 'hidden';
    if (searchInput) searchInput.focus();
    EleanorAnalytics.track('search', { action: 'open' });
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.setAttribute('data-open', 'false');
    searchOverlay.setAttribute('aria-hidden', 'true');
    searchOverlay.setAttribute('inert', '');
    searchToggle.forEach(function (button) { button.setAttribute('aria-expanded', 'false'); });
    document.body.style.overflow = '';
    if (searchReturnFocus && searchReturnFocus.focus) searchReturnFocus.focus();
  }
  searchToggle.forEach(function (btn) { btn.addEventListener('click', openSearch); });
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchOverlay && searchOverlay.getAttribute('data-open') === 'true') {
      closeSearch();
      return;
    }
    if (searchOverlay && searchOverlay.getAttribute('data-open') === 'true') {
      trapFocus(e, searchOverlay);
    } else if (mobileNav && mobileNav.getAttribute('data-open') === 'true') {
      trapFocus(e, mobileNav);
    }
  });

  /* ---------- Accordions (product details / FAQ) ---------- */
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!isOpen));
      if (!panel) return;
      if (isOpen) {
        panel.setAttribute('aria-hidden', 'true');
        panel.setAttribute('inert', '');
        panel.style.maxHeight = null;
      } else {
        panel.removeAttribute('inert');
        panel.setAttribute('aria-hidden', 'false');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });

  /* ---------- Newsletter (Shopify customer form, progressive enhancement) ---------- */
  document.querySelectorAll('[data-newsletter-form]').forEach(function (el) {
    var form = el.matches('form') ? el : el.closest('form');
    if (!form) return;
    form.addEventListener('submit', function () {
      EleanorAnalytics.track('newsletter_signup', {});
      // Native Shopify /contact#newsletter form submission handles the rest;
      // no fetch override needed — this keeps progressive enhancement / no-JS fallback intact.
    });
  });

  /* ---------- Collection view / product view events (fired from inline section data) ---------- */
  var pageType = document.body.getAttribute('data-page-type');
  if (pageType === 'collection') {
    EleanorAnalytics.track('collection_view', { handle: document.body.getAttribute('data-collection-handle') });
  }
  if (pageType === 'product') {
    EleanorAnalytics.track('product_view', { id: document.body.getAttribute('data-product-id') });
  }

  /* ---------- Cross-sell click tracking (delegated) ---------- */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-cross-sell-item]');
    if (el) EleanorAnalytics.track('cross_sell_click', { productId: el.getAttribute('data-product-id') });
  });
})();
